module.exports = __webpack_public_path__ + "fonts/GothamSSm-LightItalic_Web.7444982.woff";